import React, { useState } from 'react';
import { ScanFace } from 'lucide-react';
import api from '../../lib/api';

const TOKEN_KEY = 'crm_token';
const USER_KEY = 'crm_user';

export const PocketLogin = ({ onLoggedIn }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [remember, setRemember] = useState(true);
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e?.preventDefault();
    setBusy(true); setErr('');
    try {
      const r = await api.post('/auth/login', { email, password, remember_me: remember });
      localStorage.setItem(TOKEN_KEY, r.data.access_token);
      localStorage.setItem(USER_KEY, JSON.stringify(r.data.user));
      api.defaults.headers.common['Authorization'] = `Bearer ${r.data.access_token}`;
      onLoggedIn(r.data.user);
    } catch (e2) {
      const d = e2?.response?.data?.detail;
      setErr(typeof d === 'string' ? d : 'اسم المستخدم أو كلمة السر غير صحيحة');
    } finally { setBusy(false); }
  };

  return (
    <div className="pk-login" data-testid="pocket-login">
      <div className="pk-login-logo"><img src="/pocket-icon-512.png" alt="Pocket Up" draggable={false} /></div>
      <div className="pk-login-title" dir="ltr">POCKET <span className="neon">UP</span></div>
      <div className="pk-login-sub">by Varo Trades · نظام المصاريف الصوتي — سجّل كل حركة بثانية</div>
      <form className="pk-login-form" onSubmit={submit}>
        <input type="text" className="pk-input" placeholder="Username / Email" value={email}
          onChange={(e) => setEmail(e.target.value)} autoCapitalize="off" autoComplete="username"
          data-testid="pocket-login-email" dir="ltr" />
        <input type="password" className="pk-input" placeholder="Password" value={password}
          onChange={(e) => setPassword(e.target.value)} autoComplete="current-password"
          data-testid="pocket-login-password" dir="ltr" style={{ marginTop: 12 }} />
        <label className="pk-remember" data-testid="pocket-remember-me">
          <input type="checkbox" checked={remember} onChange={(e) => setRemember(e.target.checked)} />
          <span className="pk-remember-box" />
          <span className="pk-remember-txt">
            تذكرني لمدة 90 يوم <ScanFace size={13} style={{ verticalAlign: '-2px' }} /> — بعدها الدخول بـ Face ID فقط
          </span>
        </label>
        <div className="pk-err">{err}</div>
        <button type="submit" disabled={busy || !email || !password} className="pk-btn" data-testid="pocket-login-submit">
          {busy ? 'جارٍ التحقق…' : 'دخول النظام'}
        </button>
      </form>
    </div>
  );
};
